import classNames from 'clsx';
import React from 'react';

import { type Card as CardProps, CasinoGameHeader } from '@swf/casino';
import type { CasinoGameList as CasinoGameListProps } from '@swf/core/types/CasinoGameList';

import styles from './GamesCard.scss';
import GamesCardContent from './GamesCardContent';

interface Props extends CardProps {
  renderInfo?: CasinoGameListProps['renderInfo'];
}

const GamesCard: React.FC<Props> = ({ games, baseColor = 'green', renderInfo, ...rest }) => (
  <div className={classNames(styles.container, styles[baseColor])}>
    <div className={classNames(styles.background, styles[baseColor], styles.dark)}>
      <CasinoGameHeader className={styles.header} titleVariant="card" {...rest} />
      <GamesCardContent games={games} renderInfo={renderInfo} maxGames={rest.maxGames} />
    </div>
  </div>
);
export default GamesCard;
